import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { VehicleIdentityComponent } from './components/vehicle-identity/vehicle-identity.component';

export enum RoutesPathEnum {
  Home = 'home',
  VehicileIdentity = 'VehicleIdentity'
}

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: RoutesPathEnum.Home, component: HomeComponent },
  { path: RoutesPathEnum.VehicileIdentity, component: VehicleIdentityComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



